
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode"> 
            <commitmentReason-edit *ngSwitchCase="true"></commitmentReason-edit>
            <commitmentReason-details *ngSwitchCase="false"></commitmentReason-details>
        </div>
    </ng-template>  
</main-form-modal>